import { render, staticRenderFns } from "./Likes.vue?vue&type=template&id=67ee3374&scoped=true&lang=pug&"
import script from "./Likes.vue?vue&type=script&lang=js&"
export * from "./Likes.vue?vue&type=script&lang=js&"
import style0 from "./Likes.vue?vue&type=style&index=0&id=67ee3374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee3374",
  null
  
)

export default component.exports